import React from 'react';
import { isImage } from 'helpers/image';
import { IAttachment } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/WizardSteps/AttachmentsStep';
import { StyledImagePreview, StyledPlaceholderPreview } from './styles';

const AttachmentPreview = ({
  attachment,
  extension,
}: {
  attachment: IAttachment;
  extension: string;
}) => {
  if (attachment && isImage(attachment) && attachment.base64) {
    return <StyledImagePreview src={attachment.base64} alt="preview" />;
  }
  if (extension) {
    return <StyledPlaceholderPreview extension={extension} />;
  }

  return null;
};

export default AttachmentPreview;
